import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {CertificadosNacionaisModel} from "./certificados-nacionais.model";
import {CertificadosNacionaisService} from "./certificados-nacionais.service";
import {PaisesService} from "../paises/paises.service";
import {BasicValidators} from "../shared/basic-validators";
import {MercadoInternoMercadoriasService} from "../mercado-interno-mercadorias/mercado-interno-mercadorias.service";
import {LoginService} from "../login/login.service";
import {AssinantesService} from '../assinantes/assinantes.service';
import {LaboratoriosService} from '../laboratorios/laboratorios.service';
import {LaboratoriosEmissoresService} from '../laboratorios/laboratorios-emissores.service';
import {CertificadosObservacoesService} from '../certificados_observacoes/certificados-observacoes.service';
import {UsuariosService} from '../usuarios/usuarios.service';
import {TerminaisService} from '../terminais/terminais.service';
import {ClientesService} from '../clientes/clientes.service';
import {TiposClientesService} from '../clientes/tipos-clientes.service';
import {TerminaisNacionaisService} from '../terminais-nacionais/terminais-nacionais.service';
import {UnidadesService} from '../unidades/unidades.service';
import {UnidadesMedidasService} from '../unidades-medidas/unidades-medidas.service';

declare let $, swal: any;

@Component({
  selector: 'app-certificados-nacionais-form',
  templateUrl: './certificados-nacionais-form.component.html'
})
export class CertificadosNacionaisFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  formArquivos: FormGroup;
  title: string;
  certificado: CertificadosNacionaisModel = new CertificadosNacionaisModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  tipoCategoriaGeral = '';
  valorGRU = 0;


  listVariedades = [];
  listDefeitos = [];
  listIndicesConclusao = [];
  listIndicesClassificacao = [];
  listIndicesClassificacaoCalculado = [];
  listAssinantes = [];
  listTodosAssinantes = [];
  listLaboratorios = [];
  listEmissores = [];
  listObservacoes = [];
  listUsuarios = [];
  listTipoCategoria = [];
  listClientes = [];
  listStatus = [];
  listArquivos = [];
  listMercadorias = [];
  listTerminaisNacionais = [];
  listUnidadesFiltradas = [];
  listTodasUnidadesMedidas = [];
  listNaturezaOperacao = [
    { id: 'COMERCIALIZAÇÃO', nome: 'COMERCIALIZAÇÃO' },
    { id: 'EXPORTAÇÃO', nome: 'EXPORTAÇÃO' },
    { id: 'IMPORTAÇÃO', nome: 'IMPORTAÇÃO' }
  ];

  indicesConclusaoSelecionados = [];
  modelIndicesConclusaoSelecionados = []; // guarda os valores selecionados nos indices de conclusao

  alturaTela = 0;

  listFormaAcondicionamento = [];

  panelCollapsed: { [key: number]: boolean } = {};
  defeitosSemIndiceCollapsed: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private certificadosService: CertificadosNacionaisService,
    private mercadoriasService: MercadoInternoMercadoriasService,
    private assinantesService: AssinantesService,
    private laboratoriosService: LaboratoriosService,
    private laboratoriosEmissoresService: LaboratoriosEmissoresService,
    private certificadosObservacoesService: CertificadosObservacoesService,
    private usuariosService: UsuariosService,
    private terminaisService: TerminaisService,
    private clientesService: ClientesService,
    private tiposClientesService: TiposClientesService,
    private terminaisNacionaisService: TerminaisNacionaisService,
    private unidadesService: UnidadesService,
    private unidadesMedidasService: UnidadesMedidasService,
    private loginService: LoginService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {

    this.alturaTela = window.screen.availHeight - 250;

    this.listStatus = func.nomesStatusCertificado();
    this.listFormaAcondicionamento = func.nomesFormasAcondicionamento();

    this.form = formBuilder.group({
      id_certificado_nacional: [],
      id_cliente: ['', [
        Validators.required,
        BasicValidators.diferenteZero,
        BasicValidators.notNull
      ]],
      id_mercadoria: ['', [
        Validators.required,
        BasicValidators.diferenteZero,
        BasicValidators.notNull
      ]],
      id_variedade: [],
      id_assinante: ['', [
        Validators.required,
        BasicValidators.diferenteZero,
        BasicValidators.notNull
      ]],
      id_assinante2: ['', [
        Validators.required,
        BasicValidators.diferenteZero,
        BasicValidators.notNull
      ]],
      id_terminal: [],
      id_responsavel_coleta: [],
      numero: [],
      responsavel_coleta_nome: [],
      unidade_armazenadora: [],
      numero_amostra: [],
      peso: [],
      lote: [],
      safra: [],
      volumes: [],
      marca_comercial: [],
      procedencia: [],
      tipo_categoria: [],
      natureza_operacao: [],
      nota_fiscal: [],
      observacao: [],
      observacaobase: [],
      data_emissao: ['', [
        Validators.required
      ]],
      id_unidade: ['', [
        Validators.required,
        BasicValidators.diferenteZero,
        BasicValidators.notNull
      ]],
      numero_analise: [],
      data_emissao_analise: [],
      id_laboratorio: [],
      id_emissor: [],
      emitir_cert_class: [],
      forma_acondicionamento0: [],
    });

    this.formArquivos = formBuilder.group({
      nome_arquivo: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      arquivos: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop().substring(0,3) == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop().substring(0,3) == 'add'){
      this.pageIsAdd = true;
    }

    this.unidadesService.get()
      .subscribe(
        json => {
          if (json.Payload) {
            this.listUnidadesFiltradas = json.Payload.filter(u =>
              u.cgc && String(u.cgc).trim() !== '' &&
              u.serie_numero_certificado && String(u.serie_numero_certificado).trim() !== ''
            );
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.usuariosService.get()
      .subscribe(
        json => {
          this.listUsuarios = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.laboratoriosService.get()
      .subscribe(
        json => {
          this.listLaboratorios = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.certificadosObservacoesService.get()
      .subscribe(
        json => {
          this.listObservacoes = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.tiposClientesService.get(["clientes"])
      .subscribe(
        json => {
          let clientesMercadoInterno = [];
          if (json.Payload) {
            json.Payload.forEach(tipo => {
              const nome = (tipo.nome_pt || tipo.nome_en || tipo.nome_es || '').toLowerCase();
              if (nome.indexOf('mercado interno') !== -1 && tipo.clientes) {
                clientesMercadoInterno = clientesMercadoInterno.concat(tipo.clientes);
              }
            });
          }
          this.listClientes = this.func.mergeObjByProp([], clientesMercadoInterno, 'id_cliente');
        },
        error => {
          this.func.showErro(error.json());
        });

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.terminaisNacionaisService.get()
      .subscribe(
        json => {
          this.listTerminaisNacionais = [];
          for(let t in json.Payload){
            this.listTerminaisNacionais.push({
              "id_terminal": json.Payload[t].id_terminal,
              "nome": json.Payload[t].nome +' - '+ json.Payload[t].cidade +' - '+ json.Payload[t].estado
            });
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.assinantesService.get(['usuario'])
      .subscribe(
        json2 => {
          this.listTodosAssinantes = [];

          for(let i in json2.Payload){
            this.listTodosAssinantes.push({
              "id_assinante": json2.Payload[i].id_assinante,
              "nome": json2.Payload[i].usuario.nome
            });
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.unidadesMedidasService.get()
      .subscribe(
        json => {
          this.listTodasUnidadesMedidas = json.Payload || [];
        },
        error => {
          console.error(error);
        });

    // copia certificado existente
    this.route.queryParams.subscribe(paramsGet => {
      if(paramsGet['copiar']){
        this.carregaCertificado(paramsGet['copiar'], true);
      }
    });

    let id = this.route.params.subscribe(params => {

      let id = params['id_certificado'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarCertificado');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarCertificado') : this.func.traduzir('front.cadastrarNovoCertificado');
      }

      if (!id) {
        return;
      }

      this.carregaCertificado(id);

    });
  }

  carregaCertificado(id, isCopia = false){
    this.certificadosService.getById(id, ["defeitos"])
      .subscribe(
        json => {

          if(!isCopia){
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarCertificado')+' '+("000000" + json.Payload[0].numero).slice(-6);
            }else{
              this.title = this.func.traduzir('front.visualizarCertificado')+' '+("000000" + json.Payload[0].numero).slice(-6);
            }
          }else{
            delete json.Payload[0].defeitos;
            delete json.Payload[0].indices_conclusao;
          }


          this.assinantesService.get(['usuario', 'assina_mercadorias'])
            .subscribe(
              json2 => {
                this.listAssinantes = [];

                for(let i in json2.Payload){

                  for(let z in json2.Payload[i].assina_mercadorias){
                    if(json2.Payload[i].assina_mercadorias[z].id_mercadoria == json.Payload[0].id_mercadoria){
                      this.listAssinantes.push({
                        "id_assinante": json2.Payload[i].id_assinante,
                        "nome": json2.Payload[i].usuario.nome
                      });
                    }
                  }

                }

                if(this.global.debug == true){
                  console.log('ASSINANTES', json2.Payload);
                }
              },
              error => {
                this.func.showErro(error.json());
              });

          // adiciona formularios de formas de acondicionamento
          for(let z in json.Payload[0].forma_acondicionamento){
            console.log('adicionado', 'forma_acondicionamento'+z);
            this.form.addControl('forma_acondicionamento'+z, new FormControl('forma_acondicionamento'+z, []));
          }

          this.certificado = json.Payload[0];


          console.log('this.certificado', this.certificado);

          let defeitosCertificado = json.Payload[0].defeitos;

          if(this.certificado.id_laboratorio && this.certificado.id_laboratorio != '0'){
            this.laboratoriosEmissoresService.get(null, {"id_laboratorio": this.certificado.id_laboratorio})
              .subscribe(
                json => {
                  this.listEmissores = json.Payload;
                },
                error => {
                  this.func.showErro(error.json());
                });
          }

          this.certificado.observacaobase = 0;

          // console.log('observacoesSelecionadas', this.observacoesSelecionadas);
          // console.log('conclusoesSelecionadas', this.conclusoesSelecionadas);

          //this.indicesConclusaoSelecionados = this.certificado.indices_conclusao;

          // busca variedades, dedeitos, indices de conclusão e indices de classicação relacionados a mercadoria

          if(this.certificado.id_mercadoria){
            this.mercadoriasService.getById(this.certificado.id_mercadoria, ["variedades", "defeitos", "indices_conclusao", "indices_classificacao"])
              .subscribe( json => {

                //console.log('Variedades e Defeitos e Indices', json.Payload);

                this.listVariedades = json.Payload[0].variedades;

                this.listIndicesConclusao = json.Payload[0].indices_conclusao;
                console.log('Indices Conclusao', this.listIndicesConclusao);

                this.listIndicesClassificacao = json.Payload[0].indices_classificacao;
                console.log('Indices Classificacao', this.listIndicesClassificacao);

                this.modelIndicesConclusaoSelecionados = [];
                this.indicesConclusaoSelecionados = [];

                for (let j = 0; j < this.listIndicesConclusao.length; j++) {
                  let control: FormControl = new FormControl('indiceConclusao' + j, [Validators.required, BasicValidators.notNull]);
                  this.form.setControl('indiceConclusao' + j, control);

                  let comModelIndice = false;
                  let indObj = this.listIndicesConclusao[j];
                  let indNome = indObj.nome || indObj.nome_pt;

                  if (!indObj.itens || indObj.itens.length == 0) {
                    // Item de texto
                    if (this.certificado.indices_conclusao) {
                      for (let q in this.certificado.indices_conclusao) {
                        let certInd = this.certificado.indices_conclusao[q];
                        let certNome = certInd ? (certInd.nome || certInd.nome_pt) : null;
                        if (certInd && indNome == certNome) {
                          let val = certInd.valor;
                          this.modelIndicesConclusaoSelecionados.push(val);
                          comModelIndice = true;

                          this.indicesConclusaoSelecionados.push({
                            "nome": indNome,
                            "nome_pt": indNome,
                            "valor": val,
                            "valorGeral": val,
                            "ordem_classificacao": 0,
                            "index": 0,
                            "classificar": false
                          });
                          break;
                        }
                      }
                    }
                  } else {
                    // Item de select/dropdown
                    let selectedK = null;
                    let selectedItem = null;

                    for (let k = 0; k < indObj.itens.length; k++) {
                      let item = indObj.itens[k];
                      if (item.valor && this.listTipoCategoria.indexOf(item.valor) === -1 && item.valor != '') {
                        this.listTipoCategoria.push(item.valor);
                      }

                      if (!comModelIndice && this.certificado.indices_conclusao) {
                        for (let q in this.certificado.indices_conclusao) {
                          let certInd = this.certificado.indices_conclusao[q];
                          let certNome = certInd ? (certInd.nome || certInd.nome_pt) : null;
                          if (certInd && indNome == certNome) {
                            let valCert = certInd.valor;
                            let valCertGeral = certInd.valorGeral;
                            let itemNome = item.nome || item.nome_pt;
                            let itemValor = item.valor;

                            if (
                              itemNome == valCert ||
                              itemNome == valCertGeral ||
                              (itemValor && (itemValor == valCert || itemValor == valCertGeral)) ||
                              (valCert && itemNome && itemNome.toString().trim().toLowerCase() === valCert.toString().trim().toLowerCase())
                            ) {
                              selectedK = k;
                              selectedItem = item;
                              comModelIndice = true;
                              break;
                            }
                          }
                        }
                      }
                    }

                    if (comModelIndice && selectedItem !== null) {
                      let itemNome = selectedItem.nome || selectedItem.nome_pt;
                      this.modelIndicesConclusaoSelecionados.push(selectedK);
                      this.indicesConclusaoSelecionados.push({
                        "nome": indNome,
                        "nome_pt": indNome,
                        "valor": itemNome,
                        "valorGeral": selectedItem.valor,
                        "ordem_classificacao": selectedItem.ordem_classificacao,
                        "index": selectedK,
                        "classificar": indObj.classificar
                      });
                    }
                  }

                  if (!comModelIndice) {
                    this.modelIndicesConclusaoSelecionados.push(null);
                    this.indicesConclusaoSelecionados.push({
                      "nome": indNome,
                      "nome_pt": indNome,
                      "valor": null,
                      "valorGeral": null,
                      "classificar": indObj.classificar
                    });
                  }
                }

                // zera defeitos
                this.listDefeitos = [];
                // adiciona defeito por defeito
                for(let x in json.Payload[0].defeitos){

                  let control: FormControl = new FormControl('defeito'+x, []);
                  this.form.setControl('defeito'+x, control); // instead of this.obj[key]

                  let control2: FormControl = new FormControl('defeitoAtivo'+x, []);
                  this.form.setControl('defeitoAtivo'+x, control2); // instead of this.obj[key]

                  let valor = 0.00;
                  let ativo = true;
                  let defeitoOrig = json.Payload[0].defeitos[x];
                  let defeitoCertEncontrado = null;

                  for(let z in defeitosCertificado){
                    if(defeitosCertificado[z].id_defeito == defeitoOrig.id){
                      valor = defeitosCertificado[z].valor;
                      ativo = defeitosCertificado[z].ativo;
                      defeitoCertEncontrado = defeitosCertificado[z];
                    }
                  }

                  this.listDefeitos.push({
                    "id_defeito": defeitoOrig.id,
                    "nome_pt": defeitoOrig.nome_pt,
                    "valor": valor,
                    "ativo": ativo,
                    "is_indice_acumulado": defeitoOrig.is_indice_acumulado,
                    "indices_acumulados": defeitoOrig.indices_acumulados,
                    "id_unidade_medida": defeitoOrig.id_unidade_medida || (defeitoCertEncontrado && defeitoCertEncontrado.defeito ? defeitoCertEncontrado.defeito.id_unidade_medida : null),
                    "unidade_medida": defeitoOrig.unidade_medida || (defeitoCertEncontrado && defeitoCertEncontrado.defeito ? defeitoCertEncontrado.defeito.unidade_medida : null),
                    "ordem": defeitoOrig.ordem
                  });
                }

                this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
                this.tipoCategoriaGeral = this.func.calculaIndiceClassificacaoGeral(this.indicesConclusaoSelecionados, this.listIndicesClassificacao, this.listDefeitos, this.listIndicesClassificacaoCalculado);

                for(let c in this.listIndicesClassificacao){
                  if(this.listTipoCategoria.indexOf(this.listIndicesClassificacao[c].nome) === -1){
                    this.listTipoCategoria.push(this.listIndicesClassificacao[c].nome);
                  }
                }

              });

          }

          if(isCopia){
            this.certificado.id_certificado_nacional = null;
            this.certificado.numero = null;
            this.certificado.data_emissao = null;
            this.certificado.peso = null;
            this.certificado.volumes = null;
            this.certificado.lote = null;
            this.certificado.numero_analise = null;
            this.certificado.data_emissao_analise = null;
            this.certificado.id_laboratorio = 0;
            this.certificado.id_emissor = 0;
            this.certificado.numero_amostra = null;
            this.certificado.nota_fiscal = null;
          }

          if(this.global.debug == true){
            console.log(json.Payload[0]);
          }
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  changeMercadoria(e){

    // busca variedades, dedeitos, indices de conclusão e indices de classicação relacionados a mercadoria

    if(this.certificado.id_mercadoria){
      this.mercadoriasService.getById(this.certificado.id_mercadoria, ["variedades", "defeitos", "indices_conclusao", "indices_classificacao"])
        .subscribe( json => {

          this.assinantesService.get(['usuario', 'assina_mercadorias'])
            .subscribe(
              json2 => {
                this.listAssinantes = [];

                for(let i in json2.Payload){

                  for(let z in json2.Payload[i].assina_mercadorias){
                    if(json2.Payload[i].assina_mercadorias[z].id_mercadoria == this.certificado.id_mercadoria){
                      this.listAssinantes.push({
                        "id_assinante": json2.Payload[i].id_assinante,
                        "nome": json2.Payload[i].usuario.nome
                      });
                    }
                  }

                }

                if(this.global.debug == true){
                  console.log('ASSINANTES', json2.Payload);
                }
              },
              error => {
                this.func.showErro(error.json());
              });

          //console.log('Variedades e Defeitos e Indices', json.Payload);

          this.listVariedades = json.Payload[0].variedades;
          this.certificado.id_variedade = null;

          this.listIndicesConclusao = json.Payload[0].indices_conclusao;
          console.log('Indices Conclusao', this.listIndicesConclusao);

          this.certificado.indices_conclusao = [];
          this.indicesConclusaoSelecionados = [];
          this.certificado.tipo_categoria = '';
          this.listIndicesClassificacao = json.Payload[0].indices_classificacao;
          console.log('Indices Classificacao', this.listIndicesClassificacao);

          for(let p = 0; p < 200; p++){
            this.form.removeControl('indiceConclusao'+p);
          }

          this.modelIndicesConclusaoSelecionados = [];
          this.indicesConclusaoSelecionados = [];

          for (let j = 0; j < this.listIndicesConclusao.length; j++) {
            let control: FormControl = new FormControl('indiceConclusao' + j, [Validators.required, BasicValidators.notNull]);
            this.form.setControl('indiceConclusao' + j, control);

            let comModelIndice = false;
            let indObj = this.listIndicesConclusao[j];
            let indNome = indObj.nome || indObj.nome_pt;

            if (!indObj.itens || indObj.itens.length == 0) {
              // Item de texto
              if (this.certificado.indices_conclusao) {
                for (let q in this.certificado.indices_conclusao) {
                  let certInd = this.certificado.indices_conclusao[q];
                  let certNome = certInd ? (certInd.nome || certInd.nome_pt) : null;
                  if (certInd && indNome == certNome) {
                    let val = certInd.valor;
                    this.modelIndicesConclusaoSelecionados.push(val);
                    comModelIndice = true;

                    this.indicesConclusaoSelecionados.push({
                      "nome": indNome,
                      "nome_pt": indNome,
                      "valor": val,
                      "valorGeral": val,
                      "ordem_classificacao": 0,
                      "index": 0,
                      "classificar": false
                    });
                    break;
                  }
                }
              }
            } else {
              // Item de select/dropdown
              let selectedK = null;
              let selectedItem = null;

              for (let k = 0; k < indObj.itens.length; k++) {
                let item = indObj.itens[k];
                if (item.valor && this.listTipoCategoria.indexOf(item.valor) === -1 && item.valor != '') {
                  this.listTipoCategoria.push(item.valor);
                }

                if (!comModelIndice && this.certificado.indices_conclusao) {
                  for (let q in this.certificado.indices_conclusao) {
                    let certInd = this.certificado.indices_conclusao[q];
                    let certNome = certInd ? (certInd.nome || certInd.nome_pt) : null;
                    if (certInd && indNome == certNome) {
                      let valCert = certInd.valor;
                      let valCertGeral = certInd.valorGeral;
                      let itemNome = item.nome || item.nome_pt;
                      let itemValor = item.valor;

                      if (
                        itemNome == valCert ||
                        itemNome == valCertGeral ||
                        (itemValor && (itemValor == valCert || itemValor == valCertGeral)) ||
                        (valCert && itemNome && itemNome.toString().trim().toLowerCase() === valCert.toString().trim().toLowerCase())
                      ) {
                        selectedK = k;
                        selectedItem = item;
                        comModelIndice = true;
                        break;
                      }
                    }
                  }
                }
              }

              if (comModelIndice && selectedItem !== null) {
                let itemNome = selectedItem.nome || selectedItem.nome_pt;
                this.modelIndicesConclusaoSelecionados.push(selectedK);
                this.indicesConclusaoSelecionados.push({
                  "nome": indNome,
                  "nome_pt": indNome,
                  "valor": itemNome,
                  "valorGeral": selectedItem.valor,
                  "ordem_classificacao": selectedItem.ordem_classificacao,
                  "index": selectedK,
                  "classificar": indObj.classificar
                });
              }
            }

            if (!comModelIndice) {
              this.modelIndicesConclusaoSelecionados.push(null);
              this.indicesConclusaoSelecionados.push({
                "nome": indNome,
                "nome_pt": indNome,
                "valor": null,
                "valorGeral": null,
                "classificar": indObj.classificar
              });
            }
          }

          // zera defeitos
          this.listDefeitos = [];
          // adiciona defeito por defeito
          for(let x in json.Payload[0].defeitos){

            let control: FormControl = new FormControl('defeito'+x, []);
            this.form.setControl('defeito'+x, control); // instead of this.obj[key]

            let control2: FormControl = new FormControl('defeitoAtivo'+x, []);
            this.form.setControl('defeitoAtivo'+x, control2); // instead of this.obj[key]

            let valor = 0.00;
            let ativo = true;
            let defeitoOrig = json.Payload[0].defeitos[x];

            /*for(let z in defeitosCertificado){
              if(defeitosCertificado[z].id_defeito == json.Payload[0].defeitos[x].id){
                valor = defeitosCertificado[z].valor;
                ativo = defeitosCertificado[z].ativo;
              }
            }*/

            this.listDefeitos.push({
              "id_defeito": defeitoOrig.id,
              "nome_pt": defeitoOrig.nome_pt,
              "valor": valor,
              "ativo": ativo,
              "is_indice_acumulado": defeitoOrig.is_indice_acumulado,
              "indices_acumulados": defeitoOrig.indices_acumulados,
              "id_unidade_medida": defeitoOrig.id_unidade_medida,
              "unidade_medida": defeitoOrig.unidade_medida || null,
              "ordem": defeitoOrig.ordem
            });
          }

          this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
          this.tipoCategoriaGeral = this.func.calculaIndiceClassificacaoGeral(this.indicesConclusaoSelecionados, this.listIndicesClassificacao, this.listDefeitos, this.listIndicesClassificacaoCalculado);

          for(let c in this.listIndicesClassificacao){
            if(this.listTipoCategoria.indexOf(this.listIndicesClassificacao[c].nome) === -1){
              this.listTipoCategoria.push(this.listIndicesClassificacao[c].nome);
            }
          }

        });

    }
  }


  updateIndiceConclusao(i, event, texto = false){
    let indObj = this.listIndicesConclusao[i];
    let indNome = indObj ? (indObj.nome || indObj.nome_pt) : '';

    if (texto) {
      this.indicesConclusaoSelecionados[i] = {
        "nome": indNome,
        "nome_pt": indNome,
        "valor": event,
        "valorGeral": event,
        "index": "0",
        "classificar": indObj ? indObj.classificar : false,
        "ordem_classificacao": 0
      };
    } else {
      let val = (event && event.target) ? event.target.value : event;
      if (val === null || val === 'null' || val === '' || val === undefined) {
        this.indicesConclusaoSelecionados[i] = {
          "nome": indNome,
          "nome_pt": indNome,
          "valor": null,
          "valorGeral": null,
          "index": i,
          "classificar": indObj ? indObj.classificar : false,
          "ordem_classificacao": 0
        };
      } else {
        let idx = parseInt(val);
        if (!isNaN(idx) && indObj && indObj.itens && indObj.itens[idx]) {
          let selectedItem = indObj.itens[idx];
          let itemNome = selectedItem.nome || selectedItem.nome_pt;
          this.indicesConclusaoSelecionados[i] = {
            "nome": indNome,
            "nome_pt": indNome,
            "valor": itemNome,
            "valorGeral": selectedItem.valor,
            "index": idx,
            "classificar": indObj.classificar,
            "ordem_classificacao": selectedItem.ordem_classificacao
          };
        }
      }
    }

    this.tipoCategoriaGeral = this.func.calculaIndiceClassificacaoGeral(this.indicesConclusaoSelecionados, this.listIndicesClassificacao, this.listDefeitos, this.listIndicesClassificacaoCalculado);
  }

  voltar() {
    this._location.back();
  }

  save() {

    if (this.listDefeitos) {
      for (let i in this.listDefeitos) {
        if (this.isDefeitoPorcentagem(this.listDefeitos[i]) && parseFloat(this.listDefeitos[i].valor) > 100) {
          this.listDefeitos[i].valor = 100;
        }
      }
    }

    this.certificado.indices_conclusao = this.indicesConclusaoSelecionados;

    this.certificado['defeitos'] = this.listDefeitos;
    this.certificado['valor_gru'] = this.valorGRU;
    this.certificado['tipo_categoria'] = this.certificado.tipo_categoria;

    //console.log(this.certificado);

    let result,
      values = this.certificado; //this.form.value;

    this.enviandoForm = true;

    if (values.id_certificado_nacional) {
      result = this.certificadosService.editar(values, values.id_certificado_nacional);
    } else {
      result = this.certificadosService.adicionar(values);
    }

    result.subscribe(data => {
          //this.router.navigate(['/painel', 'certificados']);
          if (values.id_certificado_nacional) {
            this.router.navigate(['/painel', 'certificados-nacionais', values.id_certificado_nacional, 'pdf']);
          } else {
            this.router.navigate(['/painel', 'certificados-nacionais']);
          }
        },
        error => {
          let json = error.json();
          this.func.showErro(json);

          this.enviandoForm = false;

          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        });

  }

  changeDefeitos(i, e){
    if (this.listDefeitos && this.listDefeitos[i] && this.isDefeitoPorcentagem(this.listDefeitos[i]) && parseFloat(this.listDefeitos[i].valor) > 100) {
      this.listDefeitos[i].valor = 100;
      if (this.form && this.form.controls && this.form.controls['defeito' + i]) {
        this.form.controls['defeito' + i].setValue(100, { emitEvent: false });
      }
    }

    this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
    this.tipoCategoriaGeral = this.func.calculaIndiceClassificacaoGeral(this.indicesConclusaoSelecionados, this.listIndicesClassificacao, this.listDefeitos, this.listIndicesClassificacaoCalculado);

    // Se for índice acumulado, atualiza o estado ativo de todos os sub-defeitos
    if (this.listDefeitos[i].is_indice_acumulado) {
      let subDefeitos = this.getSubDefeitos(this.listDefeitos[i]);
      for (let sub of subDefeitos) {
        let subIdx = this.getDefeitoIndex(sub.id_defeito);
        if (subIdx !== -1) {
          this.listDefeitos[subIdx].ativo = e;
          if (this.form && this.form.controls && this.form.controls['defeitoAtivo' + subIdx]) {
            this.form.controls['defeitoAtivo' + subIdx].setValue(e);
          }
          if (e === false) {
            this.listDefeitos[subIdx].valor = 0;
            if (this.form && this.form.controls && this.form.controls['defeito' + subIdx]) {
              this.form.controls['defeito' + subIdx].setValue(0);
            }
          }
        }
      }
      this.recalculaIndiceAcumulado(this.listDefeitos[i].id_defeito);
    }

    // verificar se ele faz parte de algum indice acumulado
    for(let c in this.listDefeitos){
      if(this.listDefeitos[c].is_indice_acumulado){
        for(let z in this.listDefeitos[c].indices_acumulados){
          if(this.listDefeitos[c].indices_acumulados[z].id_defeito_indice == this.listDefeitos[i].id_defeito){
            this.recalculaIndiceAcumulado(this.listDefeitos[c].id_defeito);
          }
        }
      }
    }

    this.tipoCategoriaGeral = this.func.calculaIndiceClassificacaoGeral(this.indicesConclusaoSelecionados, this.listIndicesClassificacao, this.listDefeitos, this.listIndicesClassificacaoCalculado);
  }

  recalculaIndiceAcumulado(id_defeito){

    let valor = 0;

    for(let i in this.listDefeitos){
      if(this.listDefeitos[i].id_defeito == id_defeito){
        for(let z in this.listDefeitos[i].indices_acumulados){

          // busca os ids dos indices calculados para pegar o valor atual
          for(let q in this.listDefeitos){
            if(this.listDefeitos[i].indices_acumulados[z].id_defeito_indice == this.listDefeitos[q].id_defeito){
              valor = valor + parseFloat(this.listDefeitos[q].valor);
            }
          }
        }
      }
    }

    let defeitoAcumulado = this.listDefeitos.find(d => d.id_defeito == id_defeito);
    if (defeitoAcumulado && this.isDefeitoPorcentagem(defeitoAcumulado) && valor > 100) {
      valor = 100;
    }

    for(let q in this.listDefeitos){
      if(id_defeito == this.listDefeitos[q].id_defeito){
        this.listDefeitos[q].valor = valor;
        this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
      }
    }
  }

  formatValor(valor: any): string {
    if (valor === undefined || valor === null) {
      return '0,00';
    }
    let parsed = parseFloat(valor);
    if (isNaN(parsed)) {
      return '0,00';
    }
    return parsed.toFixed(2).replace('.', ',');
  }

  isDefeitoPorcentagem(defeito: any): boolean {
    if (!defeito) {
      return true;
    }
    let sigla = '';
    let nome = '';

    if (defeito.unidade_medida) {
      sigla = (defeito.unidade_medida.sigla || '').trim();
      nome = (defeito.unidade_medida.nome || '').trim().toUpperCase();
    } else if (defeito.id_unidade_medida && this.listTodasUnidadesMedidas) {
      const um = this.listTodasUnidadesMedidas.find(u => String(u.id_unidade) === String(defeito.id_unidade_medida));
      if (um) {
        sigla = (um.sigla || '').trim();
        nome = (um.nome || '').trim().toUpperCase();
      }
    }

    if (!sigla && !nome) {
      if (defeito.is_indice_acumulado && defeito.indices_acumulados && defeito.indices_acumulados.length > 0) {
        for (let sub of defeito.indices_acumulados) {
          let child = this.listDefeitos.find(d => d.id_defeito == sub.id_defeito_indice);
          if (child) {
            return this.isDefeitoPorcentagem(child);
          }
        }
      }
      return true;
    }

    return sigla === '%' || nome === 'PORCENTAGEM';
  }

  getSiglaUnidadeMedida(defeito: any): string {
    if (!defeito) {
      return '%';
    }
    if (defeito.unidade_medida && defeito.unidade_medida.sigla) {
      return defeito.unidade_medida.sigla;
    }
    if (defeito.id_unidade_medida && this.listTodasUnidadesMedidas) {
      const um = this.listTodasUnidadesMedidas.find(u => String(u.id_unidade) === String(defeito.id_unidade_medida));
      if (um && um.sigla) {
        return um.sigla;
      }
    }
    if (defeito.is_indice_acumulado && defeito.indices_acumulados && defeito.indices_acumulados.length > 0) {
      for (let sub of defeito.indices_acumulados) {
        let child = this.listDefeitos.find(d => d.id_defeito == sub.id_defeito_indice);
        if (child && child.unidade_medida && child.unidade_medida.sigla) {
          return child.unidade_medida.sigla;
        }
        if (child && child.id_unidade_medida && this.listTodasUnidadesMedidas) {
          const um = this.listTodasUnidadesMedidas.find(u => String(u.id_unidade) === String(child.id_unidade_medida));
          if (um && um.sigla) {
            return um.sigla;
          }
        }
      }
    }
    return '%';
  }

  getMaxValueDefeito(defeito: any): any {
    return this.isDefeitoPorcentagem(defeito) ? 100.00 : false;
  }

  getDefeitoIndex(id_defeito: any) {
    return this.listDefeitos.findIndex(d => d.id_defeito == id_defeito);
  }

  getSubDefeitos(defeitoAcumulado: any) {
    let list = [];
    if (defeitoAcumulado && defeitoAcumulado.indices_acumulados) {
      for (let sub of defeitoAcumulado.indices_acumulados) {
        let found = this.listDefeitos.find(d => d.id_defeito == sub.id_defeito_indice);
        if (found) {
          list.push(found);
        }
      }
    }
    return list.sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  }

  defeitoPertenceAAlgumAcumulado(defeitoId: any): boolean {
    for (let d of this.listDefeitos) {
      if (d.is_indice_acumulado && d.indices_acumulados) {
        for (let sub of d.indices_acumulados) {
          if (sub.id_defeito_indice == defeitoId) {
            return true;
          }
        }
      }
    }
    return false;
  }

  temDefeitosSemIndiceAcumulado(): boolean {
    if (!this.listDefeitos) return false;
    return this.listDefeitos.some(d => !d.is_indice_acumulado && !this.defeitoPertenceAAlgumAcumulado(d.id_defeito));
  }

  validateForm(form){
    for(let i in form['controls']){
      this.form['controls'][i].markAsTouched()
    }
  }

  changeObservacao(e){
    if(e != 0 && e != '0'){
      for(let i in this.listObservacoes){
        if(this.listObservacoes[i].id_observacao == e){
          this.certificado.observacao = this.listObservacoes[i].observacao;
        }
      }
    }
  }

  changeLaboratorio(e){

    this.certificado.id_emissor = 0;

    if(e == 0 || e == '0'){
      this.listEmissores = [];
    }else{
      this.laboratoriosEmissoresService.get(null, {"id_laboratorio": e})
        .subscribe(
          json => {
            this.listEmissores = json.Payload;
          },
          error => {
            this.func.showErro(error.json());
          });
    }

  }

  addFormaAcondicionamento(){
    let self = this;
    setTimeout(function(){
      console.log('adicionado', self.certificado.forma_acondicionamento.length);
      self.form.addControl('forma_acondicionamento'+self.certificado.forma_acondicionamento.length, new FormControl('forma_acondicionamento'+self.certificado.forma_acondicionamento.length, []));

      self.certificado.forma_acondicionamento.push({"texto": null});
    }, 100);

  }

  removeFormaAcondicionamento(i){
    this.certificado.forma_acondicionamento.splice(i, 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados-nacionais/certificados-nacionais-form.component.ts